import { render, staticRenderFns } from "./ProductDownloadTable.vue?vue&type=template&id=16918125&"
import script from "./ProductDownloadTable.vue?vue&type=script&lang=js&"
export * from "./ProductDownloadTable.vue?vue&type=script&lang=js&"
import style0 from "./ProductDownloadTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCheckbox,VChip,VIcon,VSimpleTable})
